import UICardHeader from 'UIComponents/card/UICardHeader';
import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import styled from 'styled-components';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { CARD_BORDER_RADIUS } from 'developer-docs-shared-components/config/cssConstants';
import LinkOverlay, { cardStyles, embeddedLinkStyles } from './LinkOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUICardWrapper = styled(UICardWrapper).withConfig({
  displayName: "InfoCard__StyledUICardWrapper",
  componentId: "sc-23sgw7-0"
})(["display:flex;justify-content:space-between;border-radius:", "px;", ""], CARD_BORDER_RADIUS, cardStyles);
const StyledUIRouterLink = styled(UIRouterLink).withConfig({
  displayName: "InfoCard__StyledUIRouterLink",
  componentId: "sc-23sgw7-1"
})(["", ""], embeddedLinkStyles);
const StyledContent = styled(UICardSection).withConfig({
  displayName: "InfoCard__StyledContent",
  componentId: "sc-23sgw7-2"
})(["min-height:185px;"]);
export const InfoCard = ({
  title,
  content,
  link
}) => {
  return /*#__PURE__*/_jsxs(StyledUICardWrapper, {
    children: [/*#__PURE__*/_jsx(UICardHeader, {
      title: title
    }), /*#__PURE__*/_jsx(StyledContent, {
      children: content
    }), /*#__PURE__*/_jsx(UICardSection, {
      children: /*#__PURE__*/_jsx(StyledUIRouterLink, {
        to: link.url,
        children: link.title
      })
    }), /*#__PURE__*/_jsx(LinkOverlay, {
      to: link.url
    })]
  });
};